import { VerifyResult } from '@/types'
import { validate } from 'vee-validate'

export async function validateField(field: unknown, rule: string) {
  if (field === null || field === undefined) return null

  if (typeof field === 'string' || typeof field === 'object') {
    const result = await validate(field, rule)
    return result.errors.length === 0 ? null : { rule, errors: result.errors.toString() }
  }

  return null
}

export function createVerifyResult(
  field: string,
  overrides: Partial<Omit<VerifyResult, 'field'>> = {},
): VerifyResult {
  return {
    field,
    valid: false,
    errors: [],
    failedRules: {},
    rules: '',
    ...overrides,
  }
}

type ValidationResult = { rule: string, errors: string } | null

export function applyValidationResults(
  results: ValidationResult[],
  verifyResult: VerifyResult,
): void {
  results.forEach((result) => {
    if (result) {
      verifyResult.errors.push(result.errors)
      verifyResult.failedRules[result.rule] = result.errors
    }
  })
}
